<template>
  <div id="new-ngb-team-members-list">
    <v-card class="elevation-6 rounded-lg">
      <v-sheet class="list-header" tile>
        <div class="header-top">
          <!-- Top Left: Title with Icon -->
          <div class="header-title-section">
            <div class="title-icon-wrapper">
              <v-icon color="white" class="title-icon" size="32"
                >mdi-account-multiple-plus</v-icon
              >
            </div>
            <div class="title-content">
              <h2 class="page-title">{{ NextYearName }} - {{ PageTitle }}</h2>
              <p class="page-desc">{{ PageDescription }} {{ NextYearName }}</p>
            </div>
          </div>

          <!-- Top Right: Actions -->
          <div class="header-actions-top">
            <v-chip class="year-chip-top" v-if="NextYearName">
              {{ NextYearName }}
            </v-chip>
            <v-btn
              icon
              small
              color="white"
              class="action-btn"
              @click.prevent="refreshPageData"
              v-tooltip="'Refresh List'"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>

            <v-btn
              class="action-btn-primary"
              @click.prevent="addRecordPrompt = true"
              small
            >
              <v-icon left small>mdi-plus</v-icon>
              Assign Member
            </v-btn>
          </div>
        </div>

        <!-- Bottom: Search Bar with Flying Icons -->
        <div class="header-search">
          <div class="flying-icons-container">
            <v-icon class="flying-icon" color="rgba(255,255,255,0.4)" size="40"
              >mdi-account</v-icon
            >
            <v-icon class="flying-icon" color="rgba(255,255,255,0.3)" size="36"
              >mdi-badge-account-horizontal</v-icon
            >
            <v-icon class="flying-icon" color="rgba(255,255,255,0.4)" size="38"
              >mdi-account-check</v-icon
            >
            <v-icon class="flying-icon" color="rgba(255,255,255,0.35)" size="35"
              >mdi-account-star</v-icon
            >
          </div>
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            placeholder="Search by name, designation, or membership id..."
            single-line
            hide-details
            class="search-input-modern"
          ></v-text-field>
        </div>
      </v-sheet>

      <v-card-text>
        <div class="loading-wrap" v-if="LoadingFlag">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>

        <v-container fluid v-if="!LoadingFlag">
          <v-row class="summary-row" align="center" justify="space-between">
            <v-col cols="12" sm="auto">
              <p class="found-text">
                <v-icon size="20">mdi-account-multiple</v-icon>
                <span
                  >{{ filteredRows.length }} / {{ rows.length }}
                  <span class="muted">members found</span></span
                >
              </p>
            </v-col>
          </v-row>

          <v-row v-if="filteredRows.length > 0" dense>
            <v-col
              v-for="item in filteredRows"
              :key="item.MemberId"
              cols="12"
              sm="12"
              md="6"
              lg="4"
              class="d-flex"
            >
              <v-card class="member-card" v-ripple elevation="4">
                <div class="info-row mt-3 align-left-end">
                  <v-chip
                    x-small
                    :color="
                      item.ActiveStatus === 1
                        ? 'success'
                        : item.ActiveStatus === 2
                        ? 'warning'
                        : 'error'
                    "
                    text-color="white"
                    class="status-chip"
                  >
                    <v-icon left x-small>
                      {{
                        item.ActiveStatus === 1
                          ? "mdi-check-circle"
                          : item.ActiveStatus === 2
                          ? "mdi-clock-outline"
                          : "mdi-alert-circle"
                      }}
                    </v-icon>
                    {{ item.ActiveStatusTxt }}
                  </v-chip>
                </div>

                <div class="card-top">
                  <div class="avatar-elev">
                    <v-img
                      width="90"
                      height="90"
                      :src="item.ProfilePic"
                      :alt="item.MemberFullname"
                    />
                  </div>
                  <div class="card-meta ml-3">
                    <p class="member-name">{{ item.MemberFullname }}</p>
                    <p class="member-designation">
                      <v-icon size="14">mdi-briefcase</v-icon>
                      {{ item.DesignationName }}
                    </p>
                    <p class="member-lom">
                      <v-icon size="14">mdi-map-marker</v-icon>
                      {{ item.LomName }}
                    </p>
                  </div>
                </div>

                <div class="card-body">
                  <div class="info-row">
                    <v-icon size="14" color="#1976d2">mdi-map-marker</v-icon>
                    <span class="info-label">Zone:</span>
                    <span class="info-value">{{ item.ZoneName }}</span>
                  </div>
                  <div class="info-row">
                    <v-icon size="14" color="#1976d2">mdi-card</v-icon>
                    <span class="info-label">Membership ID:</span>
                    <span class="info-value">{{ item.MembershipId }}</span>
                  </div>
                  <div class="info-row" v-if="item.MobileNo">
                    <v-icon size="14" color="#2196f3">mdi-phone</v-icon>
                    <span class="info-label">Mobile:</span>
                    <span class="info-value">{{ item.MobileNo }}</span>
                  </div>
                  <div class="info-row" v-if="item.EmailId">
                    <v-icon size="14" color="#d32f2f">mdi-email</v-icon>
                    <span class="info-label">Email:</span>
                    <span class="info-value email-value">{{
                      item.EmailId
                    }}</span>
                  </div>
                </div>

                <div class="card-actions">
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    x-small
                    color="#1976d2"
                    class="edit-btn"
                    @click="editData(item)"
                    v-if="item.DesignationId && editFlag"
                  >
                    <v-icon size="20">mdi-pencil-box-outline</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="notes-row mt-6">
            <v-col cols="12">
              <p class="notes-title">Important:</p>
              <ol class="notes-content">
                <li>
                  As per Article 4.2 of policy manual part 2, all elective post
                  members should be active members.
                </li>
                <li>
                  All the elective officers should upload their age proof
                  document under their members profile update page.
                </li>
                <li>
                  To assign NGB members for the next year click on &nbsp;
                  <span
                    style="
                      background-color: #1976d2;
                      color: white;
                      padding: 0 8px;
                      border-radius: 4px;
                    "
                  >
                    Assign Member
                  </span>
                  &nbsp; button.
                </li>
              </ol>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <!-- Add Dialog -->
    <v-dialog v-model="addRecordPrompt" persistent scrollable max-width="75%">
      <div style="max-height: 80vh; overflow-y: auto">
        <new-ngb-team-members-modify
          pageDescription="Assign National Governing board members for the year"
          :addRecordPrompt="addRecordPrompt"
          @hideAddRecordPrompt="hideAddRecordPrompt"
          v-if="addRecordPrompt"
          boardType="2"
        ></new-ngb-team-members-modify>
      </div>
    </v-dialog>

    <!-- Edit Dialog -->
    <v-dialog v-model="editRecordPrompt" persistent scrollable max-width="75%">
      <div style="max-height: 80vh; overflow-y: auto">
        <new-ngb-team-members-edit
          pageDescription="Edit National Governing board members for the year"
          :editRecordPrompt="editRecordPrompt"
          :recordData="selectedData"
          @hideEditRecordPrompt="hideEditRecordPrompt"
          v-if="editRecordPrompt"
        ></new-ngb-team-members-edit>
      </div>
    </v-dialog>

    <!-- Member Document Dialog -->
    <v-dialog v-model="memberDocumentPrompt" persistent scrollable>
      <member-document-list
        v-if="memberDocumentPrompt"
        :record="selectedData"
        :pageDescription="memberDocumentTitle"
        @hideDialog="hideMemberDocumentPrompt($event)"
      ></member-document-list>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import NewNgbTeamMembersModify from "@/view/pages/erp/team-members/new-ngb/NewNgbTeamMembersModify.vue";
import NewNgbTeamMembersEdit from "@/view/pages/erp/team-members/new-ngb/NewNgbTeamMembersEdit.vue";
import MemberDocumentList from "@/view/pages/members/MemberDocumentList.vue";

export default {
  mixins: [common],
  components: {
    NewNgbTeamMembersModify,
    NewNgbTeamMembersEdit,
    MemberDocumentList,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ResultFlag: false,

      memberDocumentPrompt: false,
      memberDocumentTitle: "",

      refreshButtonFlag: false,
      floatButtonFlag: false,

      pageTitle: "National Directory Information",
      pageDescription:
        "List of National Governing board members for the year 2022",

      rows: [],
      tableSelectFlag1: false,
      tableColumns1: [],
      selected: [],
      search: "",
      CurrentYearId: 0,

      editFlag: true,
      selectedData: {},

      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,

      zone: {},
      lom: {},

      name: "",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      select: "Item 1",
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      checkbox: false,

      FromZoneCodeRules: [(v) => !!v || "Zone is required"],
      FromZoneCode: "",
      FromZoneCodeOptions: [],
      FromZoneCodeOptionsLoading: false,

      FromLomCodeRules: [(v) => !!v || "LO is required"],
      FromLomCode: "",
      FromLomCodeOptions: [],
      FromLomCodeOptionsLoading: false,

      ToZoneCodeRules: [(v) => !!v || "Zone is required"],
      ToZoneCode: "",
      ToZoneCodeOptions: [],
      ToZoneCodeOptionsLoading: false,

      ToLomCodeRules: [(v) => !!v || "LO is required"],
      ToLomCode: "",
      ToLomCodeOptions: [],
      ToLomCodeOptionsLoading: false,

      SearchId: "",
      SearchIdRules: [(v) => !!v || "Search Type is required"],
      SearchIdOptions: [
        { value: "", text: "--Select Type--" },
        { value: 1, text: "By LO" },
        { value: 2, text: "By Membership Id" },
      ],

      MembershipId: "",
      MembershipIdRules: [(v) => !!v || "Membership Id is required"],

      YearHalfId: "",
      YearHalfIdRules: [(v) => !!v || "Year Half is required"],
      YearHalfIdOptions: [
        { value: "", text: "--Select Half--" },
        { value: "First", text: "First Half" },
        { value: "Second", text: "Second Half" },
      ],

      YearIdRules: [(v) => !!v || "Year is required"],
      YearId: "",
      YearIdOptions: [],
      YearIdOptionsLoading: false,

      ApprovalDescription: "",
      ApprovalDescriptionRules: [],

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  computed: {
    filteredRows() {
      if (!this.search) {
        return this.rows;
      }
      const query = this.search.toLowerCase().trim();
      return this.rows.filter((item) => {
        return (
          (item.MemberFullname &&
            item.MemberFullname.toLowerCase().includes(query)) ||
          (item.DesignationName &&
            item.DesignationName.toLowerCase().includes(query)) ||
          (item.LomName && item.LomName.toLowerCase().includes(query)) ||
          (item.MembershipId && item.MembershipId.toLowerCase().includes(query))
        );
      });
    },
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = NextJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        this.pageData();
      }
    },
    SearchId: function () {
      console.log("watch SearchId");
      this.rows = [];
    },
  },
  methods: {
    getStatusColor(status) {
      if (!status) return "#999999";
      const statusLower = status.toLowerCase();
      if (statusLower.includes("active")) return "#4caf50";
      if (statusLower.includes("inactive")) return "#f44336";
      if (statusLower.includes("pending")) return "#ff9800";
      if (statusLower.includes("approved")) return "#2196f3";
      return "#999999";
    },
    memberDocumentData(tr) {
      console.log("memberDocumentData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.selectedData = tr;
        this.memberDocumentTitle="Documents for " + tr.MemberFullname;
        this.memberDocumentPrompt = true;
      } else {
        var message = "Kindly select one member.";
        this.toast("error", message);
      }
    },
    hideMemberDocumentPrompt(flag) {
      console.log("hideMemberDocumentPrompt called");
      console.log({ flag });
      this.memberDocumentPrompt = false;
      if (flag) {
        // this.member.document_flag = true;
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "ngb_dis",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getTableRecords();
    },
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      this.getTableRecords();
    },
    hideEditRecordPrompt() {
      console.log("hideEditRecordPrompt called");
      this.editRecordPrompt = false;
      this.getTableRecords();
    },
    editData(tr) {
      console.log("editData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.selectedData = tr;
        this.editRecordPrompt = true;
      } else {
        var message = "Kindly select one member to edit";
        this.toast("error", message);
      }
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
      this.$refs.form3.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var LomCode = this.$session.get("LomId");
      LomCode = LomCode == (null || undefined) ? "" : LomCode;
      console.log("LomCode=" + LomCode);

      if (LomCode != null) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/year-wise-designation/lists";
        var upload = {
          UserInterface: 3,
          OrganizationTypeId: 1,
          YearCode: this.CurrentYearId,
          ExceptDesignationId: [1, 5, 7],
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.rows = [];
        this.ResultFlag = false;
        this.LoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.ResultFlag = true;
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.rows = records.TableData;
              thisIns.tableColumns1 = records.TableHeader;
              thisIns.tableSelectFlag1 = records.TableSelectFlag;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.ResultFlag = true;
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Your session is expired. Kindly login again. ";
        console.log("error=" + message);
      }
    },
    getZoneCodeOptions(source, destination) {
      console.log("getZoneCodeOptions called");
      // this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      var CurrentYearId = this.CurrentYearId;
      console.log(
        "source=" +
          source +
          ", destination=" +
          destination +
          ", CurrentYearId=" +
          CurrentYearId
      );
      if (source != "" && destination != "") {
        this.LoadingFlag = true;
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/year-wise-lom/zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: CurrentYearId,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getLomCodeOptions(source, destination, ZoneCode) {
      console.log("getLomCodeOptions called");
      console.log(
        "source=" +
          source +
          ", destination=" +
          destination +
          ", ZoneCode=" +
          ZoneCode
      );
      var CurrentYearId = this.CurrentYearId;
      if (ZoneCode != "" && CurrentYearId != "") {
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          YearCode: CurrentYearId,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "Zone should not be empty";
        this.toast("error", message);
      }
    },
    getYearCodeOptions(source, destination) {
      console.log("getYearCodeOptions called");
      // this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      // var CurrentYearId = this.CurrentYearId;
      var CurrentYearId = 1;
      console.log(
        "source=" +
          source +
          ", destination=" +
          destination +
          ", CurrentYearId=" +
          CurrentYearId
      );
      if (source != "" && destination != "") {
        this.LoadingFlag = true;
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/jci-year/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
/* Professional & Beautiful UI: Modern, clean, responsive with animations */

/* Keyframe Animations */
@keyframes flyingIcon {
  0%,
  100% {
    transform: translateY(0px) scale(1);
    opacity: 1;
  }
  25% {
    transform: translateY(-12px) scale(1.05);
  }
  50% {
    transform: translateY(-20px) scale(1.1);
  }
  75% {
    transform: translateY(-12px) scale(1.05);
  }
}

@keyframes floatingIcons {
  0% {
    transform: translateY(100px) translateX(0) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  85% {
    opacity: 1;
  }
  100% {
    transform: translateY(-100px) translateX(30px) rotate(360deg);
    opacity: 0;
  }
}

@keyframes floatingIconsAlt {
  0% {
    transform: translateY(100px) translateX(0) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  85% {
    opacity: 1;
  }
  100% {
    transform: translateY(-120px) translateX(-40px) rotate(-360deg);
    opacity: 0;
  }
}

@keyframes glow {
  0%,
  100% {
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.3),
      0 0 20px rgba(25, 118, 210, 0.3);
  }
  50% {
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.5),
      0 0 30px rgba(25, 118, 210, 0.5);
  }
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes cardGlide {
  0% {
    opacity: 0;
    transform: translateY(10px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes buttonPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(25, 118, 210, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0);
  }
}

#new-ngb-team-members-list {
  font-family: "Inter", "Roboto", sans-serif;
  animation: slideInUp 0.6s ease-out;

  .list-header {
    background: linear-gradient(135deg, #05213d 0%, #1663a3 50%, #122442 100%);
    padding: 24px 28px;
    border-radius: 16px;
    margin-bottom: 24px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 12px 35px rgba(25, 118, 210, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.15);

    &::before {
      content: "";
      position: absolute;
      top: -50%;
      right: -50%;
      width: 500px;
      height: 500px;
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.1) 0%,
        transparent 70%
      );
      animation: spin 15s linear infinite;
    }

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(255, 255, 255, 0.05) 50%,
        transparent 100%
      );
      animation: shimmer 3s infinite;
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    margin-bottom: 18px;
    position: relative;
    z-index: 2;
  }

  .header-title-section {
    display: flex;
    align-items: center;
    gap: 18px;
    flex: 1;
    min-width: 0;
  }

  .title-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 14px;
    padding: 12px;
    flex-shrink: 0;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.25);
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.25);
      animation: glow 2s ease-in-out infinite;
    }

    .title-icon {
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
    }
  }

  .title-content {
    min-width: 0;
  }

  .page-title {
    margin: 0;
    font-size: 24px;
    font-weight: 800;
    color: #ffffff;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    letter-spacing: -0.5px;
  }

  .page-desc {
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
    font-weight: 500;
    margin-top: 4px;
    letter-spacing: 0.3px;
  }

  .header-actions-top {
    display: flex;
    align-items: center;
    gap: 12px;
    white-space: nowrap;
    flex-wrap: wrap;
    justify-content: flex-end;
    position: relative;
    z-index: 2;
  }

  .year-chip-top {
    background: rgba(255, 255, 255, 0.2) !important;
    color: #ffffff !important;
    border: 1px solid rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(8px);
    transition: all 0.3s ease;
    font-weight: 600;

    &:hover {
      background: rgba(255, 255, 255, 0.3) !important;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }

  .action-btn {
    color: white !important;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 50%;
      transform: translate(-50%, -50%) scale(0);
      transition: transform 0.6s ease;
    }

    &:hover {
      transform: scale(1.15) rotate(5deg);
      box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);

      &::before {
        transform: translate(-50%, -50%) scale(1);
      }
    }

    &:active {
      transform: scale(0.95);
    }
  }

  .action-btn-primary {
    background: rgba(255, 255, 255, 0.18) !important;
    color: #ffffff !important;
    border-radius: 8px;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    border: 1px solid rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(8px);
    font-weight: 600;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(255, 255, 255, 0.2) 50%,
        transparent 100%
      );
      transition: left 0.5s ease;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.28) !important;
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
      border-color: rgba(255, 255, 255, 0.35);

      &::before {
        left: 100%;
      }
    }

    &:active {
      transform: translateY(-1px);
    }
  }

  .header-search {
    padding-top: 8px;
    position: relative;
    z-index: 2;
  }

  .flying-icons-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 120px;
    pointer-events: none;
    overflow: hidden;
    z-index: 1;
  }

  .flying-icon {
    position: absolute;
    bottom: 0;
    left: 10%;
    animation: floatingIcons var(--duration, 4s) ease-in var(--delay, 0s)
      infinite;

    &:nth-child(2) {
      left: 25%;
      animation: floatingIconsAlt var(--duration, 5s) ease-in var(--delay, 1s)
        infinite;
    }

    &:nth-child(3) {
      left: 40%;
      animation: floatingIcons var(--duration, 4.5s) ease-in var(--delay, 2s)
        infinite;
    }

    &:nth-child(4) {
      left: 55%;
      animation: floatingIconsAlt var(--duration, 5.5s) ease-in
        var(--delay, 0.5s) infinite;
    }
  }

  .search-input-modern {
    background: rgba(255, 255, 255, 0.12) !important;
    border-radius: 10px !important;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    position: relative;
    z-index: 3;
    max-width: 450px;

    &:focus-within {
      background: rgba(255, 255, 255, 0.18) !important;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
      transform: translateY(-2px);
      border-color: rgba(255, 255, 255, 0.3) !important;
    }
  }

  .search-input-modern input {
    color: #ffffff !important;
    caret-color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
  }

  .search-input-modern input::placeholder {
    color: rgba(255, 255, 255, 0.7) !important;
    -webkit-text-fill-color: rgba(255, 255, 255, 0.7) !important;
    opacity: 1 !important;
  }

  .search-input-modern ::-webkit-input-placeholder {
    color: rgba(255, 255, 255, 0.7) !important;
  }

  .search-input-modern ::-moz-placeholder {
    color: rgba(255, 255, 255, 0.7) !important;
  }

  .search-input-modern :-ms-input-placeholder {
    color: rgba(255, 255, 255, 0.7) !important;
  }

  .search-input-modern ::v-deep .v-input__slot {
    color: #ffffff !important;
  }

  .search-input-modern ::v-deep input {
    color: #ffffff !important;
    caret-color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
  }

  .search-input-modern ::v-deep .v-text-field__input {
    color: #ffffff !important;
    caret-color: #ffffff !important;
  }

  .search-input-modern ::v-deep .v-input__prepend-inner {
    color: #ffffff !important;
  }

  .search-input-modern ::v-deep .v-input__append-inner {
    color: #ffffff !important;
  }

  .search-input-modern ::v-deep .v-icon {
    color: #ffffff !important;
  }

  .search-input-modern ::v-deep .v-input__append-inner .v-icon {
    color: #ffffff !important;
  }

  .search-input-modern ::v-deep .mdi::before {
    color: #ffffff !important;
  }

  .loading-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 60px 20px;
  }

  .summary-row {
    margin-bottom: 24px;
    padding: 16px 0;
    border-bottom: 2px solid #f0f1f3;
    animation: slideInUp 0.6s ease-out 0.2s both;
  }

  .found-text {
    color: #1f2937;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
  }

  .muted {
    color: #6b7280;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
  }

  .member-card {
    border-radius: 16px;
    overflow: hidden;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06), 0 2px 8px rgba(0, 0, 0, 0.04);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    border: 1px solid rgba(25, 118, 210, 0.05);
    animation: cardGlide 0.5s ease-out both;

    &:nth-child(1) {
      animation-delay: 0.05s;
    }
    &:nth-child(2) {
      animation-delay: 0.1s;
    }
    &:nth-child(3) {
      animation-delay: 0.15s;
    }
    &:nth-child(4) {
      animation-delay: 0.2s;
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, #092c4e, #2196f3, #4e8ef7);
      transform: scaleX(0);
      transform-origin: left;
      transition: transform 0.3s ease;
      z-index: 1;
    }

    &:hover {
      transform: translateY(-12px) scale(1.02);
      box-shadow: 0 20px 40px rgba(25, 118, 210, 0.15),
        0 8px 16px rgba(0, 0, 0, 0.08);
      border-color: rgba(25, 118, 210, 0.15);

      &::before {
        transform: scaleX(1);
      }

      .position-chip {
        animation: buttonPulse 1.5s infinite;
      }
    }
  }

  .card-header-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 10;
  }

  .position-chip {
    font-weight: 700;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.8px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .status-chip {
    font-weight: 700;
    font-size: 10px;
    letter-spacing: 0.6px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .card-top {
    display: flex;
    align-items: center;
    padding: 24px 20px;
    padding-top: 32px;
    background: linear-gradient(
      135deg,
      transparent 0%,
      rgba(25, 118, 210, 0.02) 100%
    );
  }

  .avatar-elev {
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
    flex-shrink: 0;
    border: 3px solid rgba(25, 118, 210, 0.1);
    transition: all 0.3s ease;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      inset: 0;
      background: radial-gradient(
        circle at 30% 30%,
        rgba(255, 255, 255, 0.3),
        transparent 50%
      );
      border-radius: 14px;
    }

    img {
      transition: transform 0.3s ease;
    }

    &:hover {
      box-shadow: 0 16px 36px rgba(25, 118, 210, 0.2);
      transform: scale(1.05);

      img {
        transform: scale(1.08);
      }
    }
  }

  .card-meta {
    flex: 1;
    min-width: 0;
  }

  .member-name {
    font-size: 17px;
    font-weight: 800;
    color: #0f172a;
    word-break: break-word;
    background: linear-gradient(135deg, #1976d2, #2196f3);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin: 0;
    line-height: 1.3;
  }

  .member-designation {
    color: #1976d2;
    margin-top: 10px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    font-size: 14px;
  }

  .member-lom {
    color: #d32f2f;
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    font-size: 14px;
  }

  .card-body {
    padding: 18px 20px;
    border-top: 1px solid rgba(25, 118, 210, 0.05);
    background: rgba(25, 118, 210, 0.01);
  }

  .info-row {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #4b5563;
    margin-bottom: 10px;
    font-size: 13px;
    line-height: 1.6;
    transition: all 0.2s ease;

    &:hover {
      color: #1976d2;
      padding-left: 4px;
    }
  }

  .info-label {
    font-weight: 700;
    color: #374151;
    min-width: 68px;
    flex-shrink: 0;
  }

  .info-value {
    color: #6b7280;
    flex: 1;
    font-weight: 500;
    word-break: break-word;
  }

  .email-value {
    font-size: 12px;
  }

  .action-icon {
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: rotate(180deg);
      color: #1976d2 !important;
    }
  }

  .card-actions {
    padding: 14px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    border-top: 1px solid rgba(25, 118, 210, 0.05);
    background: rgba(25, 118, 210, 0.02);
    transition: all 0.3s ease;
  }

  .member-card:hover .card-actions {
    background: rgba(25, 118, 210, 0.06);
  }

  .edit-btn {
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
    
    &:hover {
      transform: scale(1.15) rotate(-5deg) !important;
      box-shadow: 0 6px 16px rgba(25, 118, 210, 0.2) !important;
    }

    &:active {
      transform: scale(1.05) !important;
    }
  }

  .notes-row {
    margin-top: 32px;
    animation: slideInUp 0.6s ease-out 0.4s both;
  }

  .notes-title {
    font-size: 17px;
    font-weight: 800;
    color: #111827;
    margin-bottom: 14px;
    position: relative;
    padding-left: 12px;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 20px;
      background: linear-gradient(180deg, #1976d2, #2196f3);
      border-radius: 2px;
    }
  }

  .notes-content {
    padding-left: 24px;
    color: #4b5563;
    line-height: 1.9;
    font-weight: 500;

    li {
      margin-bottom: 10px;
      transition: all 0.2s ease;

      &:hover {
        color: #1976d2;
        padding-left: 8px;
      }
    }
  }

  /* Responsive */
  @media (max-width: 960px) {
    .list-header {
      padding: 18px 20px;
      border-radius: 12px;
    }

    .header-top {
      flex-direction: column;
      align-items: flex-start;
      gap: 14px;
    }

    .header-title-section {
      width: 100%;
    }

    .page-title {
      font-size: 20px;
    }

    .header-actions-top {
      width: 100%;
      justify-content: flex-start;
    }

    .action-btn-primary {
      flex: 1;
    }
  }

  @media (max-width: 600px) {
    .page-title {
      font-size: 18px;
    }

    .page-desc {
      font-size: 12px;
    }

    .header-actions-top {
      gap: 8px;
      width: 100%;
    }

    .title-icon-wrapper {
      display: flex;
      padding: 10px;
    }

    .member-card {
      margin-bottom: 12px;
      border-radius: 12px;
    }

    .member-card:hover {
      transform: translateY(-8px) scale(1.01);
    }
  }
}
</style>